import { useCallback } from "react";

import { useNavigate } from "..";
import { useViewActions } from "store";
import { INotification } from "store/types";
import { NotificationHandlerType } from "./use-click-handler";

export function useChrunchbaseHook(): NotificationHandlerType {
  const { setCrunchbaseStateAction } = useViewActions();
  const navigate = useNavigate();

  return useCallback(async ({ components }: INotification) => {
    if (components.deal_id && components.deal_title) {
      navigate({ route: "dealDashboard", params: { deal_id: components.deal_id } });
      setCrunchbaseStateAction(true);
    }
  }, []);
}
